import React, { useEffect } from "react";

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import DataCloud from "./pages/dataCloud";
import MarketingCloud from "./pages/marketingCloud";
import SalesServiceCloud from "./pages/salesServiceCloud";
import LoyaltyManagement from "./pages/loyaltyManagement";
import Tableau from "./pages/tableau";
import About from "./pages/about";
import Careers from "./pages/careers";
import Contact from "./pages/contact";
import MarketingCloudPersonalization from "./pages/marketingCloudPersonalization";
import AgentForce from "./pages/agentForce";
import SmartSolutions from "./pages/SmartSolutions";
// import Engineering from "./pages/engineering/Engineering";
import FlutterSDK from "./pages/FlutterSDK";
import CustomMiddlewarePlatform from "./pages/CustomMiddlewarePlatform";
import GlobalCapabilityCenter from "./pages/GlobalCapabilityCenter";
import EngineeringServices from "./pages/EngineeringServices";
import AWSMiddlewareSalesforceDataCloud from "./pages/AWSMiddlewareSalesforceDataCloud";
import DataDeduplicationEngine from "./pages/DataDeduplicationEngine";
import AppLinkFlutterSDK from "./pages/AppLinkFlutterSDK";
import DataCloudMaturityAssessment from "./pages/DataCloudMaturityAssessment";
import SalesforceLanding from "./pages/SalesforceLanding";
import RiyaAiVoiceAgent from "./pages/RiyaAiVoiceAgent";
import Blog from "./pages/blog/Blog";
import BlogDetails from "./pages/blog/BlogDetails";
import SuccessStories from "./pages/successStories/SuccessStories";
import SuccessStoryDetails from "./pages/successStories/SuccessStoryDetails";
import Ebooks from "./pages/ebooks/Ebooks";
import EbookDetails from "./pages/ebooks/EbookDetails";
import Whitepapers from "./pages/whitepapers/Whitepapers";
import WhitepaperDetails from "./pages/whitepapers/WhitepaperDetails";
import PressReleases from "./pages/pressReleases/PressReleases";
import PressReleaseDetails from "./pages/pressReleases/PressReleaseDetails";
import Slack from "./pages/slack";

// import Services from './pages/Services';
// import Solutions from './pages/Solutions';
// import AboutUs from './pages/AboutUs';
// import ContactUs from './pages/ContactUs';
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./pages/common/header";
import Footer from "./pages/common/footer";
import PrivacyPolicy from "./pages/privacyPolicy";
import April from "./pages/Newsletter/april";
import June from "./pages/Newsletter/june";
import September from "./pages/Newsletter/september";
import October from "./pages/Newsletter/october";

import Newsletter from "./pages/newsletter";
import AIFirstDeliveryCenter from "./pages/AIFirstDeliveryCenter";
import GitexDubai from "./pages/GitexDubai";
import Yearbook05 from "./pages/Yearbook/yearbook05";

import "./App.css";
import July2023 from "./pages/Newsletter/july-2023";
import April2023 from "./pages/Newsletter/april-2023";
import August2022 from "./pages/Newsletter/august-2022";
import April2022 from "./pages/Newsletter/april-2022";
import October2021 from "./pages/Newsletter/october-2021";
import June2021 from "./pages/Newsletter/june-2021";
import January2021 from "./pages/Newsletter/january-2021";
import October2020 from "./pages/Newsletter/october-2020";
import June2020 from "./pages/Newsletter/june-2020";
import March2020 from "./pages/Newsletter/march-2020";
import December2019 from "./pages/Newsletter/december-2019";
import March2026 from "./pages/Newsletter/march-2026";
import June2026 from "./pages/Newsletter/june-2026";
import September2026 from "./pages/Newsletter/september-2026";

const App = () => {
  const location = useLocation();

  // Define paths that should NOT have header/footer
  const noHeaderFooterPaths = [
    "/newsletter/april-2025",
    "/newsletter/june-2025",
    "/newsletter/september-2025",
    "/newsletter/october-2024",
    "/AI-First-Delivery-Center",
    "/gitexdubai2025",
    "/AI-Lab-ODC",
    "/yearbook/2025",
    "/newsletter/july-2023",
    "/newsletter/april-2023",
    "/newsletter/august-2022",
    "/newsletter/april-2022",
    "/newsletter/october-2021",
    "/newsletter/june-2021",
    "/newsletter/january-2021",
    "/newsletter/october-2020",
    "/newsletter/june-2020",
    "/newsletter/march-2020",
    "/newsletter/december-2019",
    "/newsletter/march-2026",
    "/salesforce-services",
    "/newsletter/june-2026",
    "/newsletter/september-2026",
  ];

  const hideHeaderFooter = noHeaderFooterPaths.includes(location.pathname);

  useEffect(() => {
    // Prevent duplicate GTM script
    if (!document.querySelector("script[data-gtm]")) {
      const scriptTag = document.createElement("script");
      scriptTag.setAttribute("data-gtm", "true"); // marker
      scriptTag.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NXJSKDSV');
      `;
      document.head.appendChild(scriptTag);
    }

    // Prevent duplicate noscript iframe
    if (!document.querySelector("noscript[data-gtm]")) {
      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", "true"); // marker
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NXJSKDSV"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, []);

  return (
    <>
      {/* <Header /> */}
      {/* Conditionally render Header */}
      {/* {location.pathname !== '/newsletter/april-2025' && <Header />}
            {location.pathname !== '/newsletter/june-2025' && <Header />} */}

      {!hideHeaderFooter && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/smart-solutions" element={<SmartSolutions />} />
        <Route path="/data-cloud" element={<DataCloud />} />
        <Route path="/marketing-cloud" element={<MarketingCloud />} />
        <Route path="/service-cloud" element={<SalesServiceCloud />} />
        <Route path="/salesforce-services" element={<SalesforceLanding />} />
        <Route path="/riya-ai-voice-agent" element={<RiyaAiVoiceAgent />} />
        <Route path="/loyalty-management" element={<LoyaltyManagement />} />
        <Route path="/tableau" element={<Tableau />} />
        <Route path="/slack" element={<Slack />} />
        {/* <Route path="/engineering" element={<Engineering />} /> */}
        {/* <Route path="/engineering/src" element={<Engineering />} /> */}
        <Route path="/engineering" element={<EngineeringServices />} />
        <Route path="/newsletter/june-2020" element={<June2020 />} />
        <Route path="/newsletter/march-2020" element={<March2020 />} />
        <Route path="/newsletter/december-2019" element={<December2019 />} />

        <Route path="/flutter-sdk" element={<FlutterSDK />} />
        <Route
          path="/custom-middleware-platform"
          element={<CustomMiddlewarePlatform />}
        />
        <Route
          path="/global-capability-center/GCC"
          element={<GlobalCapabilityCenter />}
        />
        <Route
          path="/global-capability-center"
          element={<Navigate to="/global-capability-center/GCC" replace />}
        />
        <Route
          path="/aws-middleware-for-salesforce-data-cloud"
          element={<AWSMiddlewareSalesforceDataCloud />}
        />
        <Route
          path="/data-deduplication-engine-for-salesforce-data-cloud"
          element={<DataDeduplicationEngine />}
        />
        <Route
          path="/applink-flutter-sdk-for-salesforce-personalization"
          element={<AppLinkFlutterSDK />}
        />
        <Route
          path="/data-cloud-maturity-assessment"
          element={<DataCloudMaturityAssessment />}
        />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route
          path="/success-stories/:slug"
          element={<SuccessStoryDetails />}
        />
        <Route path="/ebooks" element={<Ebooks />} />
        <Route path="/ebook/:slug" element={<EbookDetails />} />
        <Route path="/white-papers" element={<Whitepapers />} />
        <Route path="/white-paper/:slug" element={<WhitepaperDetails />} />
        <Route path="/press-releases" element={<PressReleases />} />
        <Route path="/press-releases/:slug" element={<PressReleaseDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route
          path="/marketing-cloud-personalization"
          element={<MarketingCloudPersonalization />}
        />
        <Route path="/agent-force" element={<AgentForce />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/AI-First-Delivery-Center"
          element={<AIFirstDeliveryCenter />}
        />
        <Route path="/AI-Lab-ODC" element={<GitexDubai />} />

        <Route path="/gitexdubai2025" element={<GitexDubai />} />
        <Route path="/newsletter/april-2025" element={<April />} />
        <Route path="/newsletter/june-2025" element={<June />} />
        <Route path="/newsletter/september-2025" element={<September />} />
        <Route path="/newsletter/october-2024" element={<October />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/yearbook/2025" element={<Yearbook05 />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/newsletter/july-2023" element={<July2023 />} />
        <Route path="/newsletter/april-2023" element={<April2023 />} />
        <Route path="/newsletter/august-2022" element={<August2022 />} />
        <Route path="/newsletter/april-2022" element={<April2022 />} />
        <Route path="/newsletter/october-2021" element={<October2021 />} />
        <Route path="/newsletter/june-2021" element={<June2021 />} />
        <Route path="/newsletter/january-2021" element={<January2021 />} />
        <Route path="/newsletter/october-2020" element={<October2020 />} />
        <Route path="/newsletter/march-2026" element={<March2026 />} />
        <Route path="/newsletter/june-2026" element={<June2026 />} />
        <Route path="/newsletter/september-2026" element={<September2026 />} />
        {/* Catch-all route for non-existent pages */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Conditionally render Footer */}
      {/* {location.pathname !== '/newsletter/april-2025' && <Footer />}
      {location.pathname !== '/newsletter/june-2025' && <Footer />} */}

      {/* <Footer/> */}

      {!hideHeaderFooter && <Footer />}
    </>
  );
};

export default App;
